'use client';

import { mq } from '@/lib/StyledComponents/mq';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 7.5rem 0;
`;

const MarkdownContainer = styled.div`
  max-width: 40rem;
  text-align: center;

  p {
    margin-bottom: 1.5rem;
  }

  ${mq(null, 'tablet')} {
    width: 90%;
    p {
      font-size: 14px;
    }
  }
`;

export const AboutFAQ = ({ markdown }: { markdown: string }) => {
  return (
    <Container>
      <MarkdownContainer
        dangerouslySetInnerHTML={{ __html: markdown }}
      ></MarkdownContainer>
    </Container>
  );
};
